import store from '@/store'

export function hasTeamAddRights(appPageId) {
    if (!store.state.selectedTeamPermissions) return false
    const permission = store.state.selectedTeamPermissions
                .find(p => p.appPageId === appPageId)
    return permission && permission.add
}

export function hasTeamEditRights(appPageId) {
    if (!store.state.selectedTeamPermissions) return false
    const permission = store.state.selectedTeamPermissions
                .find(p => p.appPageId === appPageId)
    return permission && permission.edit
}

export function hasTeamDeleteRights(appPageId) {
    if (!store.state.selectedTeamPermissions) return false
    const permission = store.state.selectedTeamPermissions
                .find(p => p.appPageId === appPageId)
    return permission && permission.delete
}

export function hasTeamApproverRights(appPageId) {
    if (!store.state.selectedTeamPermissions) return false
    const permission = store.state.selectedTeamPermissions
                .find(p => p.appPageId === appPageId)
    return permission && permission.approver
}

export function hasTeamExportRights(appPageId) {
    if (!store.state.selectedTeamPermissions) return false
    const permission = store.state.selectedTeamPermissions
                .find(p => p.appPageId === appPageId)
    return permission && permission.export
}
